module.exports = __webpack_public_path__ + "2d49a139c574890dcc6e660a1841639a.jpg";